var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnviar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8319 4.64807C13.9403 4.24356 13.5669 3.87498 13.1638 3.98855L4.017 6.56572C3.53856 6.70053 3.48098 7.3555 3.92855 7.57172L7.32221 9.21113C7.67476 9.38144 7.96796 9.65382 8.16372 9.9929L10.4051 13.8752C10.6457 14.2918 11.2699 14.2096 11.3944 13.7449L13.8319 4.64807ZM12.7808 2.62918C14.2381 2.21857 15.5879 3.55115 15.1961 5.0136L12.7586 14.1104C12.3084 15.7905 10.0517 16.0876 9.18206 14.5813L6.94064 10.699C6.88649 10.6053 6.80539 10.5299 6.70788 10.4828L3.31422 8.8434C1.69607 8.0617 1.90426 5.69371 3.63399 5.20635L12.7808 2.62918Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11934 10.9509C6.83697 10.6819 6.82613 10.235 7.09513 9.95258L13.5978 3.12658L14.6204 4.10072L8.1177 10.9267C7.8487 11.2091 7.40172 11.2199 7.11934 10.9509Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnviar);
export default __webpack_public_path__ + "static/media/icon_enviar.0b8b59321f648327baa33a8255414ba8.svg";
export { ForwardRef as ReactComponent };